<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		<div class="duration-v2">
			<button type="button" class="action-panel" (click)="edit()">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					timer
				</span>
				<span class="action-panel-value" *ngIf="timer$ | async as time">
					{{ time.hours | number: "2.0-0" }}{{ "CHECKLISTS__QUESTIONS__DURATION_HOURS" | transloco }}
					{{ time.minutes | number: "2.0-0" }}{{ "CHECKLISTS__QUESTIONS__DURATION_MINUTES" | transloco }}
					{{ time.seconds | number: "2.0-0" }}{{ "CHECKLISTS__QUESTIONS__DURATION_SECONDS" | transloco }}
				</span>
			</button>

			<div class="duration-v2-controls">
				@if (running === false && totalSeconds === 0) {
					<button
						type="button"
						class="duration-v2-btn"
						(click)="start()"
						[attr.aria-label]="'CHECKLISTS__QUESTIONS__DURATION_CONFIRM' | transloco"
					>
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							play_arrow
						</span>
					</button>
				}
				@if (running) {
					<button type="button" class="duration-v2-btn" (click)="stop()">
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							stop
						</span>
					</button>
				}
				@if (running === false && totalSeconds > 0) {
					<button type="button" class="duration-v2-btn duration-v2-btn--tonal" (click)="reset()">
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							refresh
						</span>
					</button>
				}
			</div>
		</div>
	} @else {
		<div class="duration-container">
			<div class="timer" *ngIf="timer$ | async as time" (click)="edit()">
				{{ time.hours | number: "2.0-0" }}
				<span class="number-denotation">{{ "CHECKLISTS__QUESTIONS__DURATION_HOURS" | transloco }}</span>

				{{ time.minutes | number: "2.0-0" }}
				<span class="number-denotation">{{ "CHECKLISTS__QUESTIONS__DURATION_MINUTES" | transloco }}</span>

				{{ time.seconds | number: "2.0-0" }}
				<span class="number-denotation">{{ "CHECKLISTS__QUESTIONS__DURATION_SECONDS" | transloco }}</span>
			</div>

			<ion-button (click)="start()" *ngIf="running === false && this.totalSeconds === 0">
				<ion-icon name="play"></ion-icon>
			</ion-button>

			<ion-button (click)="stop()" *ngIf="running">
				<ion-icon name="stop"></ion-icon>
			</ion-button>

			<ion-button (click)="reset()" *ngIf="running === false && this.totalSeconds > 0">
				<ion-icon name="refresh"></ion-icon>
			</ion-button>
		</div>
	}
</app-question-template>
